import request from "@/untils/request.js"

export const getOpeningBalance = (params) => {
    return request.get("/outpatient/finance/selFinance", {params})
}

export const editOpeningBalance = (data) => {
    return request.post("/outpatient/finance/edit", data)
}

export const renewalOpeningBalance = (data) => {
    return request.get("/outpatient/finance/sync", data)
}

export const startOpeningBalance = (data) => {
    return request.get("/outpatient/finance/start", data)
}

export const selFinanceReport = (params) => {
    return request.get("/outpatient/finance/selFinanceReport", {params})
}